import React, { useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Navbar from "../../components/Navbar";
import CreateMeetingForm from "./CreateMeetingForm";
import { useNavigate } from "react-router-dom";

const CreateMeetingDashboard = () => {
  const navigate = useNavigate();
  const { isAdmin } = useContext(AuthContext);
  useEffect(() => {
    if (!isAdmin) {
      navigate("/", { replace: true });
    }
  }, [isAdmin, navigate]);

  return (
    <div
      className="min-h-screen w-screen flex flex-col"
      style={{
        background: "linear-gradient(to bottom, #24004266 40%, #4FCBE6 100%)",
      }}
    >
      {/* Navbar on top */}
      <Navbar />

      {/* Main content centered below Navbar */}
      <div className="flex flex-1 items-center justify-center px-4 mt-10">
        <div className="max-w-xl w-full bg-white shadow-lg rounded-lg p-6 space-y-6">
          <h2 className="text-3xl font-semibold text-gray-800 text-center">
            Create Meeting
          </h2>
          <CreateMeetingForm />
        </div>
      </div>
    </div>
  );
};

export default CreateMeetingDashboard;
